import PreviewModal from './PreviewModal';

export default PreviewModal;
